import {UserDetails} from '../api/mirana-api';
import {mirana} from '@wize/mirana-proto/mirana-proto';

export default class MiranaState {

    private readonly isAuthenticated: boolean = false;
    private readonly isLoading: boolean = false;
    private readonly userDetails: UserDetails;
    private readonly carterasDetalles: Map<string, mirana.CarteraDetalle> = new Map();

    public constructor(oldState?: MiranaState) {
        if (oldState) {
            oldState = Object.assign(this, oldState);
            this.isAuthenticated = oldState.getIsAuthenticated();
            this.isLoading = oldState.getIsLoading();
            this.userDetails = oldState.getUserDetails();
            this.carterasDetalles = oldState.getCarterasDetalles();
        }
    }

    public getIsAuthenticated(): boolean {
        return this.isAuthenticated;
    }

    public getIsLoading(): boolean {
        return this.isLoading;
    }

    public getUserDetails(): UserDetails {
        return this.userDetails;
    }

    public getCarterasDetalles(): Map<string, mirana.CarteraDetalle> {
        return this.carterasDetalles;
    }

    public getRawState(): object {
        // can't use spread operator yet w/TS: https://github.com/Microsoft/TypeScript/pull/13288
        return Object.assign({}, this);
    }
}



// WEBPACK FOOTER //
// ./src/reduxstore/mirana-state.ts